import { api } from './cliente.js';
import type { StatusDerivado } from './tipos.js';

export type NivelIndicador = 'Projeto' | 'Programa' | 'Portfolio';
export type Tendencia = 'Melhorando' | 'Estavel' | 'Piorando';

export interface Indicador {
  id: string;
  nome: string;
  nivel: NivelIndicador;
  contextoId: string;
  dono: string;
  fonteDado: string;
  formula: string;
  baseline: number | null;
  meta: number;
  janelaFrescorDias: number;
  criadoPor: string;
  criadoEm: string;
}

export interface LinhaPainel {
  indicador: Indicador;
  valor: number | null;
  status: StatusDerivado | null;
  tendencia: Tendencia | null;
  fresco: boolean;
  calculadoEm: string | null;
}

export interface IndicadorMedicao {
  id: string;
  indicadorId: string;
  valor: number;
  calculadoEm: string;
  ator: string;
}

export const scorecardsApi = {
  painel: (nivel: NivelIndicador, contextoId: string) => api.get<LinhaPainel[]>(`/scorecards/${nivel}/${contextoId}`),
  medicoes: (indicadorId: string) => api.get<IndicadorMedicao[]>(`/indicadores/${indicadorId}/medicoes`),
};
